import type { SanityResolvedFile } from '@metmuseum/types';
import type { AnchorHTMLAttributes } from 'react';
import DownloadIcon from 'assets/icons/download.svg';
import { humanizeFileSize } from 'helpers/helpers';

type DownloadButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
	file: SanityResolvedFile['asset'];
	showIcon?: boolean;
	sizePrecision?: number;
	text?: string;
	variant?: 'secondary' | 'tertiary';
};

const DownloadButton = ({
	className,
	file,
	onClick,
	showIcon = true,
	sizePrecision = 1,
	text = 'Download PDF',
	variant = 'tertiary',
	...remainingProps
}: DownloadButtonProps) => {
	const classes = ['button', variant];
	className && classes.push(className);
	const fileSize = file.size
		? humanizeFileSize(file.size, sizePrecision)
		: null;

	return (
		<a
			{...remainingProps}
			href={file.url}
			className={classes.join(' ')}
			onClick={onClick}
		>
			{fileSize ? `${text} (${fileSize})` : text}
			{showIcon && <DownloadIcon />}
		</a>
	);
};

export default DownloadButton;
